import React, { Component } from 'react';

import { s3CacheUrl } from '../Common/util';

export const LAUNQuote = (props) => (
  <div className={"collabs-banner-quote laun-fg tile is-5"}>
    {`“We worked together with Katherine, finding the perfect color combinations to work with our furniture but also as stand-alone fabrics suitable for a variety of indoor/outdoor applications.”`}
    <div className={"collabs-banner-byline"}>
      —LAUN Los Angeles
    </div>
  </div>
);

export const LAUNBio = (props) => (
  <div className={"collabs-bio"}>
    <div className={"collabs-divider laun-bg"} />

    <div className={"collabs-section white white tile is-ancestor"}>
      <div className={'collabs-bio-image-container tile is-5'}>
        <img className={"collabs-bio-image"} alt={"Katherine Flynn × LAUN Los Angeles"} src={s3CacheUrl("https://s3.amazonaws.com/weft-public-assets/images/weft-shop-collab/laun/Katherine_Flynn_LAUN_01.jpg", 1000)} />
      </div>
      <div className={"collabs-bio-header tile is-5 margin-left-36"}>
        <h1>Katherine Flynn × LAUN Los Angeles</h1>
        <p>LAUN is a collaborative design firm marrying glamour and pleasure with the built world. In 2018, friends Rachel Bullock and Molly Purnell brought together their backgrounds in woodworking, metal working and architecture to build a practice of enduring spaces and products.</p>
      </div>
    </div>

    <div className={"collabs-section grey"}>
      <div className={"bio-content"}>
        <p>LAUN teamed up with LA-based interior and textile designer Katherine Flynn Neel on a line of WeftOut fabrics featuring delicate patterns in a rich color palette. “We love the painterly quality of Katherine’s work and we knew it would be a perfect complement for our DeMille and Bobbin collections.”</p>

        <p>Neel’s ‘Lines’ and ‘Color Block’ patterns were paired with LAUN’s new Bobbin Chair and Mini Bobbin. The graceful, hand-drawn lines and the brushed-quality of the blocks in Neel’s patterns contrast with the geometric waves of the Bobbin collection. The gold and silver anodized finish on the aluminum Bobbin rails became the backdrop for the golds and greens upholstered on the bolsters. “We worked together with Katherine, finding the perfect color combinations to work with our furniture but also as stand-alone fabrics suitable for a variety of indoor/outdoor applications.”</p>

        <p>While LAUN’s DeMille lounge chair and DeMille Sofa take inspiration from the designs of Hollywood Regency, the delicate lines of the frame were a perfect complement for Neel’s ‘Leaves’ pattern  “A lot of the fabrics in Hollywood Regency used the ubiquitous palm leaf, we felt the ‘Leaves’ pattern was a nice modernization of that look.”</p>

      </div>
    </div>
  </div>
);
